export const COLUMN_MENU_LABELS = {
    title: 'Colunas',
    resetToDefault: 'Restaurar padrão',
    buttonAriaLabel: 'Escolher colunas visíveis',
    dragHandle: 'Arrastar para reordenar',
} as const;
